// extracted by mini-css-extract-plugin
export default {"ApplicationLink":"P1RCl2oNYGzG1nBS7Coh","Icon":"hS3SCeFSqpjevWBVlJHZ"};